import QRCodeStyling from "qr-code-styling";

export const generateQrCode = () => {
  const selector = document.querySelector(
    "[data-qrcode-styling]",
  ) as HTMLDivElement;
  if (selector) {
    const data = selector.getAttribute("data-qrcode-styling") ?? "";
    const width = selector.getAttribute("data-width") ?? 150;
    const height = selector.getAttribute("data-height") ?? 150;
    // @ts-ignore
    const qrCode = new QRCodeStyling({
      width,
      height,
      type: "svg",
      margin: 7,
      data,
      image: "/wp-content/themes/seplay/assets/images/qrcodelogo.svg",
      dotsOptions: {
        color: "#000000",
        type: "square",
      },
      backgroundOptions: {
        color: "#fff",
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
        imageSize: 0.2,
      },
    });
    qrCode.append(selector);
  }
};
